import React, {Component} from 'react';
import {
  Modal as ModalB
}                         from 'react-bootstrap';

class Modal extends Component {
  render() {
    let {
      showModal,
      stateSetter,
      children
    } = this.props;

    return (
      <ModalB
        show={showModal}
        onHide={() => stateSetter([{state: 'showModal', value: false}])}
        >
        <ModalB.Header closeButton>
          <ModalB.Title>VIEW</ModalB.Title>
        </ModalB.Header>
        <ModalB.Body>
          {children}
        </ModalB.Body>
      </ModalB>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./components/AuditTrail/Modal.js